import { PdfColor } from '../../pdf/pdf';
import { BackScreenBase } from './BackScreenBase';

export class BackScreen__Green extends BackScreenBase {
  backgroundColor = PdfColor.fromRgb(0, 128, 0);
  genName = 'Image.BackScreen__Green';
}
